import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=2ada4e5a"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"
import style0 from "./EventItem.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports